export const _rightMenuFr = {
    dashboard: 'Tableau de bord',
    manage: 'Gestion de compte',
    buy: 'Vos achats',
    shop: 'Boutique',
    success: 'Succès',
};

export const _rightMenuEn = {
    dashboard: 'Dashboard',
    manage: 'Manage account',
    buy: 'Your purchases',
    shop: 'Shop',
    success: 'Success',
};

export const _rightMenuDe = {
    dashboard: 'Instrumententafel',
    manage: 'Konto verwalten',
    buy: 'Ihre Einkäufe',
    shop: 'Geschäft',
    success: 'Erfolg',
};
